import type { DiagramType } from '../../../core/tools/interfaces/ITool';

const EDGE_RENDER_DIAGRAM_TYPES = new Set<DiagramType>([
  'genogram',
  'flowchart',
  'mindmap',
  'network',
  'org',
]);

export const resolveEdgeRenderDiagramType = (
  diagramType: unknown,
  sessionDiagramType: unknown,
): Extract<DiagramType, 'genogram' | 'flowchart' | 'mindmap' | 'network' | 'org'> => {
  const raw = typeof diagramType === 'string' && diagramType.length > 0
    ? diagramType
    : typeof sessionDiagramType === 'string' && sessionDiagramType.length > 0
      ? sessionDiagramType
      : 'genogram';

  return EDGE_RENDER_DIAGRAM_TYPES.has(raw as DiagramType)
    ? raw as Extract<DiagramType, 'genogram' | 'flowchart' | 'mindmap' | 'network' | 'org'>
    : 'genogram';
};

export const resolveFrameCreationDiagramType = (
  diagramType: unknown,
): DiagramType => {
  return typeof diagramType === 'string' && diagramType.length > 0
    ? diagramType as DiagramType
    : 'generic';
};
